import { Grid } from '@mui/material'
import CellHOC from 'platform/react/hoc/list/cell'

const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    backgroundColor: theme.palette.background.selected,
    borderRadius: '50%',
    padding: theme.spacing(0.8),
  },
  flag: {
    width: '1.2rem',
    height: '1.2rem'
  }
})
/**
 * ListItemCellFlag element.
 *
 * Displays an icon.
 *
 * @param {Object} classes  styling for the cell
 * @param {Object} props    element's properties
 * @returns {JSX.Element} the new ListItemCellFlag element
 */
export const ListItemCellFlag = (classes, props = {}) => {
  const { address = {} } = props
  const { country } = address
  const iconName = country.toLowerCase()
  const iconPath = `assets/icon/${iconName || 'generic'}.svg`
  const iconAlt = `${iconName}-flag`

  return (
    <Grid className={classes.root}>
      <img
        alt={iconAlt}
        src={iconPath}
        className={classes.flag}
      />
    </Grid>
  )
}

export default CellHOC(ListItemCellFlag, styles)
